<template>
  <v-app>
    <!-- <h1>Purchase Confirmation</h1> -->

    <div :class="[$style.container, 'mx-auto pb-2']">
      <v-card color="gray100">
        <v-card-title>Envía:</v-card-title>

        <v-card-text>
          <div v-for="i in billingData" :key="i.name">
            {{ i.value }}
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mt-7" color="gray100">
        <v-card-title>Recibe:</v-card-title>

        <v-card-text>
          <div v-for="i in shippingData" :key="i.name">
            {{ i.value }}
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mt-7" color="gray100">
        <v-card-title>Detalles de la tarjeta:</v-card-title>

        <v-card-text>
          <div v-for="i in giftCard" :key="i.name">
            {{ i.value }}
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mt-7" color="gray100">
        <v-card-title>Fecha y hora de envío estimada:</v-card-title>

        <v-card-text>
          <div v-for="i in shippingDelivery" :key="i.name">
            {{ i.value }}
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mt-7" color="gray100">
        <v-card-title>medio de pago:</v-card-title>

        <v-card-text>
          <h4>{{ paymentMethodSelected }}</h4>
        </v-card-text>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

// const Vue = process.env.NODE_ENV === 'production' ? window.Vue : VuePack

@Component
export default class PurchaseConfirmation extends Vue {
  formData = null

  btnDestroy = null

  mounted() {
    // const form = document.getElementsByName('checkout')
    this.formData = document.querySelector('form[name="checkout"]')
    this.paymentMethodSelected = document.querySelector(
      'input[name="payment_method"]:checked'
    )
    this.paymentMethodSelected = this._.get(
      this.paymentMethodSelected,
      'labels.0.outerText'
    )

    this.btnDestroy = document.querySelector('.actions a[href="#previous"]')
    this.btnDestroy.onclick = () => {
      console.log('destroy')
      this.$destroy()
      // this.$el.parentNode.removeChild(this.$el)
    }

    setTimeout(() => {
      console.log('formData', document.getElementsByName('checkout'))
      console.log(
        'this.paymentMethodSelected',
        this.paymentMethodSelected.labels[0].outerText
      )
      // console.log('formData', this.billingData)
      // console.log('formData', this.shippingData)
    }, 500)
  }

  beforeDestroy() {
    console.log('destroy')
    this.btnDestroy.onclick = null
    const $el = document.createElement('div')
    $el.setAttribute('id', 'bn-purchase-confirmation')
    this.$root.$el.parentNode.appendChild($el)
    this.$root.$el.parentNode.removeChild(this.$root.$el)
  }

  get billingData() {
    return (
      this.formData &&
      this._.filter(this.formData, (i) => {
        // console.log('field', i.name.includes('billing'))
        return i.name.includes('billing')
      })
    )
  }

  get shippingData() {
    return (
      this.formData &&
      this._.filter(this.formData, (i) => {
        if (
          [
            'shipping_country',
            'shipping_delivery_date',
            'shipping_delivery_time',
            'shipping_card_from',
            'shipping_card_to',
            'shipping_card_reason',
            'shipping_card_message',
          ].includes(i.name) ||
          i.type === 'hidden'
        ) {
          return false
        }
        console.log('shippingField', i.name, i.value)
        return i.name.includes('shipping')
      })
    )
  }

  get shippingDelivery() {
    return (
      this.formData &&
      this._.filter(this.formData, (i) => {
        return i.name.includes('shipping_delivery')
      }).map((item) => {
        if (item.name === 'shipping_delivery_date') {
          console.log('shipping_delivery_date', item.value)

          return {
            name: item.name,
            value: new Date(
              `${item.value}T00:00:00.000+00:00`
            ).toLocaleDateString('es-CO', {
              timeZone: 'UTC',
              // weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            }),
          }
        } else if (item.name === 'shipping_delivery_time') {
          console.log('shipping_delivery_time', item.value)

          return {
            name: item.name,
            value: item.value, // this._.get(item, `${item.value}.label`),
          }
        }

        return item
      })
    )
  }

  get giftCard() {
    return (
      this.formData &&
      this._.filter(this.formData, (i) => {
        if (
          [
            'shipping_card_from',
            'shipping_card_to',
            'shipping_card_reason',
            'shipping_card_message',
          ].includes(i.name)
        ) {
          return true
        }

        return false
      })
    )
  }
}
</script>

<style lang="scss" module>
.container {
  width: 98%;
}
</style>

<style lang="scss" scoped>
::v-deep {
  .v-application--wrap {
    min-height: auto;
  }
}
</style>
